import { render, staticRenderFns } from "./PendingSensitivities.vue?vue&type=template&id=3b178e1e&"
import script from "./PendingSensitivities.vue?vue&type=script&lang=ts&"
export * from "./PendingSensitivities.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports